import React from "react";
import Box from "@mui/material/Box";
import { TabPanelProps } from "./custom-tab-panel-component.props";

const CustomTabPanelComponent = (props: TabPanelProps) => {
  const { children, value, index, isCampaigns, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={`${!isCampaigns ? 'custom-tab' : ''}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default CustomTabPanelComponent;
